import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + '/';

const Apis = {
    getNewsClueDeptResult: host + 'reportResult/getNewsClueDeptResult',//单位线索统计
    getNewsCluePersonResult: host + 'reportResult/getNewsCluePersonResult',//个人线索统计
    getExport: host + 'exceptResult/exportNewsClueDeptResult',//一键导出
};

export const getNewsClueDeptResult = (body, callBack) => {  //单位线索统计
    request({url:Apis.getNewsClueDeptResult, body, callBack});
};
export const getNewsCluePersonResult = (body, callBack) => {  //个人线索统计
    request({url:Apis.getNewsCluePersonResult, body, callBack});
};
export const getExport = (body, callBack) => {  // 一键导出
    request({url:Apis.getExport, method:"getFile", body, callBack});
};
